import { useEffect } from 'react'
import { wsService } from '@/services/websocket'
import { useAuth } from '@/contexts/AuthContext'
import { config } from '@/config/environment'

export function WebSocketProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  
  useEffect(() => {
    // Connect when authenticated and real-time alerts are enabled
    if (user && config.features.enableRealTimeAlerts) {
      console.log('Initializing WebSocket connection...')
      wsService.connect().catch((error) => {
        console.error('Failed to connect to WebSocket:', error)
      })
    }
    
    // Disconnect on unmount or when user logs out
    return () => {
      if (wsService.isConnected) {
        console.log('Disconnecting WebSocket...')
        wsService.disconnect()
      }
    }
  }, [user])
  
  // Handle page visibility changes to reconnect when user returns
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && user && config.features.enableRealTimeAlerts) {
        // Reconnect if user comes back to the tab and we're not connected
        if (!wsService.isConnected) {
          console.log('Page visible, reconnecting WebSocket...')
          wsService.connect().catch(console.error)
        }
      }
    }
    
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [user])
  
  return <>{children}</>
}